import { getAssetLink } from '@/helpers/get-asset-link'

export const getPersonAvatarSrc = (avatar: string | null) =>
  getAssetLink({ file: avatar ?? undefined, path: 'chitown-avatar/avatar' })
